export default __webpack_public_path__ + "static/media/y_wdt_c_3.328663a3.mp3";